export enum TipoDiagnostico {
  User = "USER",
  Team = "TEAM",
}
